<template>
	<div class="home-page">
		<div class="glow glow-1"></div>
		<div class="glow glow-2"></div>
		<div class="glow glow-3"></div>

		<header class="topbar">
			<div class="top-spacer"></div>
			<h1>SOULMATE</h1>
			<button type="button" class="lang-btn" @click="$router.push('/language')">
				<img :src="currentLangIcon" alt="" />
			</button>
		</header>

		<div class="banner-section">
			<swiper class="banner-swiper" :options="bannerSwiperOption">
				<swiper-slide v-for="(v, key) in banners" :key="key">
					<div class="banner-item">
						<van-image class="banner-img" :src="v.url">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
					</div>
				</swiper-slide>
			</swiper>
		</div>

		<div class="home-scroll">
			<section class="block">
				<div class="section-head">
					<div class="section-title">{{ $t("index.task") }}</div>
					<button type="button" class="section-more" @click="gotoMenu('/Game')">
						<span>{{ $t("index.more") }}</span>
						<svg viewBox="0 0 24 24" aria-hidden="true">
							<path d="m9 6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</button>
				</div>

				<div class="task-grid">
					<button
						type="button"
						class="task-item"
						v-for="(v, key) in gameitem"
						:key="key"
						@click="toLottery(v.key, v.id)"
					>
						<van-image class="task-img" :src="v.ico">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
						<div class="task-name">{{ v.name }}</div>
					</button>
				</div>
			</section>

			<van-pull-refresh
				pulling-text="Sao chép nhanh quy trình thả xuống"
				loosing-text="Bản sao nhắc nhở của quá trình phát hành"
				loading-text="Loading"
				success-text="Refresh successful"
				v-model="isLoading"
				@refresh="onRefresh"
			>
				<section class="block">
					<div class="section-head">
						<div class="section-title">{{ $t("index.hot") }}</div>
						<button type="button" class="section-more" @click="gotoMenu('/Choose')">
							<span>{{ $t("index.more") }}</span>
							<svg viewBox="0 0 24 24" aria-hidden="true">
								<path d="m9 6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</button>
					</div>

					<div class="mate-grid">
						<button
							type="button"
							class="mate-card"
							v-for="(v, key) in companions"
							:key="v.id || key"
							@click="toCompanion(v)"
						>
							<img class="mate-photo" :src="v.img" alt="" />
							<span class="mate-verified">Verified</span>
							<div class="mate-info">
								<div v-if="companionTag(v)" class="mate-tag">{{ companionTag(v) }}</div>
								<div class="mate-name-line">
									<div class="mate-name">{{ v.name || v.xuanfei_name }}</div>
									<div class="mate-score">
										<svg class="mate-heart" viewBox="0 0 24 24" aria-hidden="true">
											<path d="M12 20s-7-4.4-7-9.1C5 8 6.8 6.2 9.2 6.2c1.3 0 2.4.6 2.8 1.6.4-1 1.5-1.6 2.8-1.6 2.4 0 4.2 1.8 4.2 4.7C19 15.6 12 20 12 20z" fill="currentColor"/>
										</svg>
										<span>{{ companionScore(v) }}</span>
									</div>
								</div>
							</div>
						</button>
					</div>
				</section>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			lang: "en_us",
			notice: this.$t("index.loading"),
			banners: [{}],
			basicData: [],
			gameitem: [{}, {}, {}, {}],
			movielist_0: [{}, {}, {}, {}],
			movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
			companions: [],
			isLoading: false,
			movielistSwiperOption: {
				slidesPerView: "auto",
				spaceBetween: 0,
				slidesPerGroup: 1
			},
			bannerSwiperOption: {
				slidesPerView: 1,
				spaceBetween: 0,
				speed: 800,
				autoplay: true,
				grabCursor: true
			},
			serviceLeft: 30,
			serviceTop: 500,
			isDragging: false,
			dragStartX: 0,
			dragStartY: 0
		};
	},
	computed: {
		currentLangIcon() {
			const map = {
				en_us: require("../images/language/en_us.png"),
				yn_yu: require("../images/language/yn_yu.png"),
				zh_cn: require("../images/language/zh_cn.png"),
				es_spa: require("../images/language/es_spa.png"),
				ms_my: require("../images/language/ms_my.png")
			};
			return map[this.lang] || map.en_us;
		}
	},
	methods: {
		loadLuxuryFonts() {
			if (document.getElementById("luxury-login-fonts")) {
				return;
			}
			const link = document.createElement("link");
			link.id = "luxury-login-fonts";
			link.rel = "stylesheet";
			link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&family=Plus+Jakarta+Sans:wght@300;400;500;600;700&display=swap";
			document.head.appendChild(link);
		},
		gotoMenu(router) {
			this.$router.replace(router);
		},
		toLottery(key, id) {
			if (!localStorage.getItem("token")) {
				this.$router.push({ path: "/Login" });
			} else {
				this.$router.push({
					path: "/Lottery?key=" + key + "&id=" + id
				});
			}
		},
		toPlayVideo(id) {
			if (!localStorage.getItem("token")) {
				this.$router.push({ path: "/Login" });
			} else {
				this.$router.push({
					path: "/PlayVideo?id=" + id
				});
			}
		},
		onRefresh() {
			setTimeout(() => {
				this.getBasicConfig();
				this.isLoading = false;
				this.$toast("Refresh successful");
			}, 500);
		},
		getBasicConfig() {
			this.$http({
				method: "get",
				url: "sys_config"
			}).then(res => {
				this.basicData = res.data;
				this.getNotice(this.basicData);
				this.getBanner(this.basicData);
				this.getGameItem();
				this.getMovieList_0(this.basicData);
				this.getMovieList_1(this.basicData);
				this.getCompanionList();
			});
		},
		getCompanionList() {
			this.$http({
				method: "get",
				url: "xuanfeilist"
			}).then(res => {
				const list = Array.isArray(res.data) ? res.data : [];
				this.companions = this.shuffleList(list).slice(0, 8);
			});
		},
		shuffleList(list) {
			const next = list.slice();
			for (let i = next.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				const current = next[i];
				next[i] = next[j];
				next[j] = current;
			}
			return next;
		},
		companionTag(item) {
			if (!item || !item.flag) return "";
			return String(item.flag).split(",")[0].trim();
		},
		companionScore(item) {
			const raw = item && item.number !== undefined && item.number !== null && item.number !== ""
				? item.number
				: item && item.dianzan;
			const num = Number(raw);
			if (!Number.isFinite(num)) return raw || "0.0";
			return num.toFixed(1);
		},
		toCompanion(item) {
			if (!item || !item.id) return;
			if (!localStorage.getItem("token")) {
				this.$router.push({ path: "/Login" });
			} else {
				this.$router.push({ path: "/list?id=" + item.id });
			}
		},
		getNotice(data) {
			this.notice = data.notice;
		},
		getGameItem() {
			this.$http({
				method: "get",
				url: "lottery_hot"
			}).then(res => {
				this.gameitem = res.data;
			});
		},
		getMovieList_0(data) {
			this.movielist_0 = data.movielist_0;
		},
		getMovieList_1(data) {
			this.movielist_1 = data.movielist_1;
		},
		getBanner(data) {
			this.banners = data.banners;
		},
		startDrag(e) {
			e.stopPropagation();
			this.isDragging = true;

			const clientX = e.clientX || e.touches[0].clientX;
			const clientY = e.clientY || e.touches[0].clientY;

			this.dragStartX = clientX - this.serviceLeft;
			this.dragStartY = clientY - this.serviceTop;

			document.addEventListener("mousemove", this.onDrag);
			document.addEventListener("mouseup", this.endDrag);
			document.addEventListener("touchmove", this.onDrag);
			document.addEventListener("touchend", this.endDrag);
		},
		onDrag(e) {
			if (!this.isDragging) return;
			e.preventDefault();

			const clientX = e.clientX || e.touches[0].clientX;
			const clientY = e.clientY || e.touches[0].clientY;

			let newLeft = clientX - this.dragStartX;
			let newTop = clientY - this.dragStartY;

			const maxLeft = window.innerWidth - 80;
			const maxTop = window.innerHeight - 80;

			newLeft = Math.max(0, Math.min(newLeft, maxLeft));
			newTop = Math.max(0, Math.min(newTop, maxTop));

			this.serviceLeft = newLeft;
			this.serviceTop = newTop;
		},
		endDrag() {
			this.isDragging = false;
			document.removeEventListener("mousemove", this.onDrag);
			document.removeEventListener("mouseup", this.endDrag);
			document.removeEventListener("touchmove", this.onDrag);
			document.removeEventListener("touchend", this.endDrag);
		},
		handleServiceClick() {
			if (!this.isDragging) {
				this.$toast("客服功能即将上线");
			}
		}
	},
	mounted() {
		this.loadLuxuryFonts();
		document.documentElement.classList.add("luxury-login-root");
		document.body.classList.add("luxury-login-root");
		this.lang = localStorage.getItem("lang") || this.$i18n.locale || "en_us";
		this.$i18n.locale = this.lang;
		localStorage.setItem("lang", this.lang);
	},
	beforeDestroy() {
		document.documentElement.classList.remove("luxury-login-root");
		document.body.classList.remove("luxury-login-root");
	},
	created() {
		this.getBasicConfig();
	}
};
</script>

<style lang="less" scoped>
.home-page {
	position: relative;
	min-height: 100vh;
	padding-bottom: calc(96PX + env(safe-area-inset-bottom));
	background:
		radial-gradient(120% 46% at 50% -10%, rgba(148, 98, 36, 0.34), transparent 56%),
		radial-gradient(70% 32% at 100% 22%, rgba(112, 36, 72, 0.22), transparent 62%),
		radial-gradient(64% 28% at 0% 58%, rgba(120, 86, 28, 0.16), transparent 64%),
		linear-gradient(180deg, #1a140f 0%, #100d13 34%, #0c0a10 68%, #08070b 100%);
	color: #e2e8f0;
	font-family: "Plus Jakarta Sans", "PingFang SC", "Microsoft YaHei", sans-serif;
	overflow-x: hidden;
}

.glow {
	position: absolute;
	border-radius: 50%;
	pointer-events: none;
	z-index: 0;
}

.glow-1 {
	top: -80PX;
	right: -90PX;
	width: 280PX;
	height: 280PX;
	background: radial-gradient(circle at 30% 30%, rgba(126, 46, 92, 0.42), rgba(212, 175, 55, 0.2) 46%, transparent 72%);
	filter: blur(70PX);
}

.glow-2 {
	top: 220PX;
	left: -100PX;
	width: 240PX;
	height: 240PX;
	background: radial-gradient(circle at 60% 40%, rgba(212, 168, 62, 0.28), transparent 70%);
	filter: blur(70PX);
}

.glow-3 {
	top: 680PX;
	right: -120PX;
	width: 280PX;
	height: 280PX;
	background: radial-gradient(circle at 40% 40%, rgba(92, 34, 64, 0.32), transparent 70%);
	filter: blur(76PX);
}

.topbar {
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 64PX;
	padding: calc(8PX + env(safe-area-inset-top)) 16PX 0;
	background: linear-gradient(180deg, rgba(28, 20, 14, 0.72), rgba(28, 20, 14, 0));
}

.top-spacer,
.lang-btn {
	width: 40PX;
	height: 40PX;
}

.topbar h1 {
	margin: 0;
	font-family: "Cormorant Garamond", "Songti SC", "Noto Serif SC", serif;
	font-size: 28PX;
	font-weight: 600;
	line-height: 1;
	letter-spacing: 0.08em;
	background: linear-gradient(135deg, #fff0ca 0%, #f3d079 42%, #c89932 100%);
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
}

.lang-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	border: 1PX solid rgba(212, 175, 55, 0.28);
	border-radius: 14PX;
	background: rgba(255, 244, 214, 0.08);
	box-shadow: inset 0 1PX 0 rgba(255, 236, 196, 0.16);
	color: inherit;
}

.lang-btn img {
	width: 22PX;
	height: 22PX;
	border-radius: 50%;
	object-fit: cover;
}

.home-scroll {
	position: relative;
	z-index: 1;
	padding: 8PX 16PX 0;
}

.banner-section {
	position: relative;
	z-index: 1;
	margin: 8PX 12PX 18PX;
	overflow: hidden;
	border-radius: 8PX;
}

.banner-swiper {
	width: 100%;
	height: 168PX;
	overflow: hidden;
	border-radius: 8PX;
}

.banner-swiper .swiper-slide {
	width: 100%;
	height: 168PX;
	overflow: hidden;
	border-radius: 8PX;
}

.banner-item,
.banner-img {
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	overflow: hidden;
	border-radius: 8PX;
}

.banner-item {
	overflow: hidden;
	border: 1PX solid rgba(244, 216, 131, 0.22);
	border-radius: 8PX;
	background: rgba(255, 255, 255, 0.03);
	box-shadow: 0 14PX 30PX rgba(0, 0, 0, 0.38);
}

::v-deep .banner-img,
::v-deep .banner-img .van-image__img {
	width: 100%;
	height: 100%;
	border-radius: 8PX;
	object-fit: cover;
}

.block {
	margin-bottom: 14PX;
	padding: 14PX 12PX 12PX;
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background:
		linear-gradient(180deg, rgba(255, 244, 214, 0.075), rgba(255, 255, 255, 0.028) 34%, rgba(18, 14, 22, 0.35));
	box-shadow: 0 12PX 26PX rgba(0, 0, 0, 0.28), inset 0 1PX 0 rgba(255, 236, 196, 0.1);
}

.section-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10PX;
}

.section-title {
	display: flex;
	align-items: center;
	gap: 8PX;
	color: #f9eab8;
	font-size: 16PX;
	font-weight: 650;
	line-height: 1.2;
}

.section-title::before {
	content: "";
	width: 3PX;
	height: 14PX;
	border-radius: 99PX;
	background: linear-gradient(180deg, #fff1c8, #c9963a);
	box-shadow: 0 0 8PX rgba(212, 175, 55, 0.45);
}

.section-more {
	display: inline-flex;
	align-items: center;
	gap: 2PX;
	padding: 0;
	border: 0;
	background: transparent;
	color: #ecc250;
	font: inherit;
	font-size: 12PX;
	font-weight: 600;
}

.section-more svg {
	width: 14PX;
	height: 14PX;
}

.task-grid {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 8PX;
}

.task-item,
.video-card {
	padding: 0;
	border: 1PX solid rgba(244, 216, 131, 0.16);
	background: linear-gradient(180deg, rgba(255, 248, 230, 0.08), rgba(255, 255, 255, 0.03));
	box-shadow: inset 0 1PX 0 rgba(255, 255, 255, 0.06), 0 6PX 14PX rgba(0, 0, 0, 0.18);
	color: inherit;
	font: inherit;
	text-align: center;
}

.task-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	min-width: 0;
	padding: 10PX 4PX 8PX;
	border-radius: 8PX;
}

.task-img {
	width: 48PX;
	height: 48PX;
}

::v-deep .task-img .van-image__img {
	border-radius: 8PX;
	object-fit: cover;
}

.task-name {
	width: 100%;
	margin-top: 8PX;
	overflow: hidden;
	color: rgba(255, 255, 255, 0.82);
	font-size: 11PX;
	font-weight: 600;
	line-height: 1.25;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mate-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10PX;
}

.mate-card {
	position: relative;
	overflow: hidden;
	height: 236PX;
	padding: 0;
	border: 1PX solid rgba(244, 216, 131, 0.34);
	border-radius: 8PX;
	background: #140f18;
	color: inherit;
	font: inherit;
	text-align: left;
}

.mate-photo {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.mate-verified {
	position: absolute;
	top: 8PX;
	right: 8PX;
	z-index: 1;
	padding: 2PX 8PX;
	border-radius: 999PX;
	background: linear-gradient(135deg, #fff4d2 0%, #e7c56a 100%);
	color: #4a3410;
	font-size: 10PX;
	font-weight: 700;
	line-height: 1.45;
}

.mate-info {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1;
	padding: 36PX 10PX 10PX;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.82) 72%);
}

.mate-tag {
	display: inline-block;
	max-width: 100%;
	padding: 1PX 6PX;
	overflow: hidden;
	border: 1PX solid rgba(246, 214, 122, 0.85);
	border-radius: 999PX;
	color: #f8e7b0;
	font-size: 10PX;
	font-weight: 700;
	line-height: 1.35;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mate-name {
	margin-top: 4PX;
	min-width: 0;
	flex: 1;
	overflow: hidden;
	color: #fff;
	font-size: 14PX;
	font-weight: 700;
	line-height: 1.2;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mate-name-line {
	display: flex;
	align-items: center;
	gap: 6PX;
	margin-top: 4PX;
}

.mate-name-line .mate-name {
	margin-top: 0;
}

.mate-score {
	display: flex;
	align-items: center;
	flex: none;
	gap: 4PX;
	color: #ff6d8f;
	font-size: 12PX;
	font-weight: 700;
	line-height: 1;
}

.mate-heart {
	width: 12PX;
	height: 12PX;
	flex: none;
}

.video-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10PX;
}

.video-card {
	overflow: hidden;
	border-radius: 8PX;
	text-align: left;
	background: #17131c;
}

.video-thumb-wrap {
	width: 100%;
	height: 132PX;
	background: rgba(255, 255, 255, 0.05);
}

.video-thumb {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.video-title {
	display: -webkit-box;
	min-height: 34PX;
	margin: 0;
	padding: 8PX 10PX 10PX;
	overflow: hidden;
	color: rgba(255, 255, 255, 0.88);
	font-size: 12PX;
	font-weight: 600;
	line-height: 1.35;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

::v-deep .van-pull-refresh__head,
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
	color: rgba(249, 234, 184, 0.7);
	font-size: 12PX;
}

::v-deep .van-loading__spinner {
	color: #ecc250;
}
</style>
